import {type PayloadAction} from "@reduxjs/toolkit";
import {type ConfigurationValidationErrors} from "../types";

export const parametersMatch = (
  allParameters: Record<string, unknown>,
  expectedParameters: Record<string, unknown>
): boolean => {
  return Object.keys(expectedParameters).every(
    key => expectedParameters[key] === allParameters[key]
  );
};

export function clearValidationAction<T extends {validationErrors: ConfigurationValidationErrors}>(
  state: T,
  action: PayloadAction<{
    name?: keyof ConfigurationValidationErrors;
    parameters?: Record<string, unknown>;
  }>
) {
  const key = action.payload.name;

  if (!key) {
    state.validationErrors = {};
    return;
  }

  const {[key]: originalValidation, ...remainingValidation} = state.validationErrors;

  const parameters = action.payload.parameters;

  const changedValidation =
    !parameters || Object.keys(parameters).length === 0 || !originalValidation
      ? []
      : originalValidation.filter(
          validation => !parametersMatch(validation.parameters, parameters)
        );

  state.validationErrors = {
    ...remainingValidation,
    ...(changedValidation.length > 0 && {[key]: changedValidation})
  };
}
